import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { BiArrowBack } from 'react-icons/bi';
import styled from 'styled-components';
import { useAppSelector } from 'store/hooks';
import { Table } from 'components/settings/catalog/Lines/Table/Table';
import { CreateAndEditLine } from 'components/settings/catalog/Lines/CreateAndEditLine';
import { useGetCatalogData } from 'hooks/useGetCatalogData';
import { CustomAlert } from 'components/common/Alert/Alert';
import { useDispatch } from 'react-redux';
import { resetLinesStatus } from 'features/Catalog/Store/store';

interface ILines {
  id: any;
  name: string;
}

const LinesTable = () => {
  useGetCatalogData();
  const dispatch = useDispatch();
  const [lineStatus, setLineSelected] = useState({
    line: {} as ILines,
    viewLine: false,
    addLine: false,
  });
  const {
    lines: allLines,
    lineToDelete,
    updateLine,
    newLine,
  } = useAppSelector(state => state.products);
  const [lines, setLines] = useState(allLines);
  const history = useHistory();

  const handleSearch = (toSearch: string) => {
    if (toSearch.length) {
      const linesResult: ILines[] = [];

      allLines.forEach(line => {
        if (line.name.toLowerCase().includes(toSearch.toLowerCase())) {
          linesResult.push(line);
        }
      });

      setLines(linesResult);
      return;
    }
    setLines(allLines);
  };

  useEffect(() => {
    if (allLines.length) {
      setLines(allLines);
      return;
    }
    setLines([]);
  }, [allLines]);

  return (
    <Container>
      <CustomAlert
        description={lineToDelete.message}
        status={lineToDelete.status}
        onModalCLose={() => dispatch(resetLinesStatus())}
      />
      <CustomAlert
        description={updateLine.message}
        status={updateLine.status}
        onModalCLose={() => dispatch(resetLinesStatus())}
      />
      <CustomAlert
        description={newLine.message}
        status={newLine.status}
        onModalCLose={() => dispatch(resetLinesStatus())}
      />

      <ArrowBack onClick={() => history.goBack()} />
      <Search placeholder='Buscar línea' onChange={({ target }) => handleSearch(target.value)} />

      <AddContainer>
        <AddLine onClick={() => setLineSelected({ ...lineStatus, addLine: true })}>
          Agregar línea
        </AddLine>
      </AddContainer>

      <Table
        lines={lines}
        viewLine={(line: ILines) => setLineSelected({ ...lineStatus, line, viewLine: true })}
      />

      <CreateAndEditLine
        openModal={lineStatus.addLine || lineStatus.viewLine}
        closeModal={setLineSelected}
        lineStatus={lineStatus}
      />
    </Container>
  );
};

export default LinesTable;

const Container = styled.div`
  width: calc(100% - 24px);
  max-width: 1200px;
  margin: 12px auto 0 auto;
  height: 100%;
  background: var(--chakra-colors-white-primary);
  border-radius: 12px 12px 0 0;
  display: flex;
  flex-direction: column;
`;

const Search = styled.input`
  margin: 24px auto 0 auto;
  width: 100%;
  max-width: 600px;
  padding: 8px;
  font-size: 1em;
  color: var(--chakra-colors-black-primary);
  background: #f5f8fa;
  border-radius: 8px;
  outline: none;

  &::placeholder {
    font-size: 1em;
    color: var(--chakra-colors-gray-primary);
  }
`;

const AddLine = styled.button`
  padding: 2px 4px;
  font-size: 0.8em;
  color: var(--chakra-colors-green-degraded);
  background: var(--chakra-colors-green-primary);
  font-weight: 700;
  border-radius: 4px;
  transition: 0.3s ease-in-out;

  &:hover {
    background: var(--chakra-colors-green-primaryHover);
  }
  &:focus {
    outline: none;
    background: var(--chakra-colors-green-primaryHover);
  }
`;

const AddContainer = styled.div`
  width: 100%;
  max-width: 820px;
  margin: auto;
  display: flex;
  justify-content: flex-end;
  margin: 24px auto 0 auto;
`;

const ArrowBack = styled(BiArrowBack)`
  font-size: 24px;
  color: var(--chakra-colors-black-primary);
  margin: 8px auto 0 8px;
  font-weight: 700;
  cursor: pointer;
  transition: 0.3s ease-in-out;

  &:hover {
    transform: translateX(-3px);
  }
`;
